<template>

  <!-- slide -->
  <div v-if="audioType === 'slide'" id="slide">

    <div class="slide">
      <template v-for="(audioData, audioIdx) in audioList">
        <div class="slide-image square" :style="{backgroundImage: `url(${audioData.image})` }" :class="{ 'slide-show' : (playIndex == audioIdx) }"></div>
      </template>
    </div>

    <div id="contents" class="pd-lr-20">
      <div id="controller" class="buttons-audio" :class="playing ? 'playing': ''">
        <div class="buttons-play-area">
          <a @click="playingAudio()" class="button-icon" :class="playing ? 'pause': 'play'"></a>
          <div class="play-label">{{ playing ? $t('play.pause') : $t('play.play') }}</div>
          <div class="play-time">{{ currentTime }} / {{ durationTime }}</div>
        </div>
        <div class="buttons-play-area">
          <a @click="replayAudio()" class="button-icon replay" :class="(current && current > 0) ? 'on': ''"></a>
        </div>
      </div>

      <!-- audio tag is inserted from audio.js -->
    </div>
  </div>
  <!-- /slide -->

  <!-- audio -->
  <div v-else id="audio">
    <div id="contents" class="pd-lr-20">
      <div id="controller" class="buttons-audio" :class="playing ? 'playing': ''">
        <div class="buttons-play-area">
          <a @click="playingAudio()" class="button-icon" :class="playing ? 'pause': 'play'"></a>
          <div class="play-label">{{ playing ? $t('play.pause') : $t('play.play') }}</div>
          <div class="play-time">{{ currentTime }} / {{ durationTime }}</div>
        </div>
        <div class="buttons-play-area">
          <a @click="replayAudio()" class="button-icon replay" :class="(current && current > 0) ? 'on': ''"></a>
        </div>
      </div>

      <!-- audio tag is inserted from audio.js -->
    </div>
  </div>
  <!-- /audio -->

</template>

<script>
import {mapGetters} from 'vuex';
import {audioListPlayer} from '../../helpers/audio';

export default {
  name: "LessonMultiAudio",
  props: {
    audioList: {
      type: Array,
      required: true
    },
    audioType: {
      type: String,
      required: true
    },
    driver: {
      type: Object
    },
    coachStep: {
      type: Number
    },
    hasAudioEl: {
      type: Boolean
    }
  },
  data(){
    return{
      // selectedSpeed: 1,
      // optionSpeed: [
      //   { id: 1, val: 0.5, name: '0.5x' }, 
      //   { id: 2, val: 0.75, name: '0.75x' }, 
      //   { id: 3, val: 1, name: 'Normal' }, 
      //   { id: 4, val: 1.25, name: '1.25x' }, 
      //   { id: 5, val: 1.5, name: '1.5x' },
      //   { id: 5, val: 4, name: '4x' },
      // ],
      audio: undefined,
      audioListPlayer: undefined,
      playList: [],
      stopAutoSkip: false,
      playIndex: 0,
      playing: false,

      current: 0,
      totalSec: 0,
    }
  },
  computed: {
    ...mapGetters([
      'selectedLanguage'
    ]),
    currentTime() {
      return this.audioListPlayer ? this.audioListPlayer.formatTime(this.current) : '00:00'
    },
    durationTime() {
      return this.audioListPlayer ? this.audioListPlayer.formatTime(this.totalSec) : '00:00'
    },
  },
  
  created() {
  },

  mounted() {
    
    let ref = this
    ref.audioListPlayer = new audioListPlayer();

    // create audio playlist
    Array.prototype.forEach.call(Object(ref.audioList), (row, idx) => {
      ref.playList.push({ file : row.audio, stopautoskip: ref.stopAutoSkip, plyr: null });
    })
    ref.audioListPlayer.setPlaylist(ref.playList);

    ref.audio = document.querySelectorAll('audio')[ref.playIndex];
    // ref.audio.addEventListener('timeupdate', (event) => {
    //   ref.current = ref.audioListPlayer.getCurrentTime();
    // });

    ref.audioListPlayer.setCallback((type) => {
      if(type == 'end') {
        console.log('end')
        ref.playIndex = 0
        ref.playing = false
      } else if(type == 'skip') {
        console.log('skip')
        // ref.totalSec += ref.audioListPlayer.getDuration();
        ref.playIndex = ref.playIndex + 1;
      } else if(type == 'play') {
        ref.totalSec = ref.audioListPlayer.getDuration()
      }
      ref.$emit('playevent', { type: type, index: ref.playIndex })
    });
    
    ref.audioListPlayer.setTimeupdate(time => {
      ref.current = time
    });
    
    ref.totalSec = ref.audioListPlayer.getDuration()

  },
  watch: {
    playing() {
      if (this.playing) {
        this.playAudio()
      } else {
        this.pauseAudio()
      }
    },
    // playIndex:{
    //   handler (newPlayIndex, oldPlayIndex) {
    //     // this.current += this.duration
    //     this.audio = document.querySelectorAll('audio')[newPlayIndex]
    //     this.audio.addEventListener('timeupdate', (event) => {
    //       this.current = this.audioListPlayer.getCurrentTime() + this.totalSec;
    //     });
    //     // this.duration = this.audioListPlayer.getDuration();
    //   }
    // }
  },
  methods: {
    playingAudio() {
      this.playing = !this.playing
    },
    rateAudio(speed) {
      console.log('rateAudio')
      console.log(speed)
      this.audioListPlayer.rate(speed);
    },
    replayAudio() {
      console.log('replayAudio')
      this.playIndex = 0;
      this.playing = true
      this.audioListPlayer.skipTo(this.playIndex);
    },
    playAudio() {
      if(this.driver) {
        if(this.driver.hasHighlightedElement()) {
          this.playing = false
          this.audioListPlayer.stop();
          return false
        }
        if(this.hasAudioEl && this.coachStep <= 1) {
          this.playing = false
          this.audioListPlayer.stop();
          return false
        }
      }
      
      console.log('playAudio')
      this.playing = true
      this.audioListPlayer.play();
    },
    pauseAudio() {
      console.log('pauseAudio')
      this.playing = false
      this.audioListPlayer.pause();
    },
    stopAudio() {
      console.log('stopAudio')
      this.playing = false
      this.audioListPlayer.stop();
    },
  }
}
</script>

